import {
  type AgxDialogControlProps,
  AgxButton,
  AgxModal,
  AgxSpacer,
  AgxTypography,
  Icon_AlertCircleOutline,
  Icon_FeaturedIcon,
} from '@urbanx/agx.ui-components2';
import './DestructiveActionConfirmationModal.scss';

interface DestructiveActionConfirmationModalProps extends AgxDialogControlProps {
  title: string;
  message: string;
  confirmButtonText: string;
  onConfirm: () => void;
}

const DestructiveActionConfirmationModal = ({
  isOpen,
  title,
  message,
  confirmButtonText,
  onConfirm,
  setIsDialogOpen,
}: DestructiveActionConfirmationModalProps) => {
  if (!isOpen) return null;

  const actionButtons = (
    <AgxSpacer
      className="destructiveActionConfirmationModal-actions"
      direction="horizontal"
      gap="spacing-xl"
      contentJustification="center"
      fill
    >
      <AgxButton
        id="cancel-destructive-action"
        text="Cancel"
        variant="hollow"
        size="large"
        onClick={() => setIsDialogOpen(false)}
        stretch
      />
      <AgxButton
        id="confirm-destructive-action"
        text={confirmButtonText}
        variant="primary"
        danger
        size="large"
        onClick={() => {
          onConfirm();
          setIsDialogOpen(false);
        }}
        stretch
      />
    </AgxSpacer>
  );

  return (
    <AgxModal
      id="destructive-action-confirmation-modal"
      isOpen
      title={title}
      type="single"
      variant="withoutDivider"
      actionButtonContainerStyle="withDivider"
      maxWidth="600px"
      setIsDialogOpen={setIsDialogOpen}
      titleIcon={
        <Icon_FeaturedIcon
          icon={<Icon_AlertCircleOutline type="Danger" />}
          color="var(--text-error)"
          backgroundColor="var(--bg-error-light)"
        />
      }
      content={
        <div className="destructiveActionConfirmationModal-content">
          <AgxTypography
            id="destructive-action-confirmation-message"
            type="body"
            size="medium"
            color="var(--text-secondary)"
          >
            {message}
            <br />
            This action cannot be undone. Do you wish to continue?
          </AgxTypography>
        </div>
      }
      actionButtons={actionButtons}
    />
  );
};

export default DestructiveActionConfirmationModal;
